import { useState } from 'react'
import dayjs from 'dayjs'

const FIELD_CONFIG = [
  { key: 'name', label: 'Matter Name', type: 'text', required: true },
  { key: 'number', label: 'Matter Number', type: 'text' },
  { key: 'attorney', label: 'Responsible Attorney', type: 'text' },
  { key: 'billingPartner', label: 'Billing Partner', type: 'text' },
  { key: 'clientName', label: 'Client', type: 'text' },
  { key: 'practiceArea', label: 'Practice Area', type: 'text' },
  {
    key: 'feeArrangement',
    label: 'Fee Arrangement',
    type: 'select',
    options: ['', 'Hourly', 'Flat Fee', 'Contingency', 'Retainer', 'Pro Bono'],
  },
  { key: 'openDate', label: 'Open Date', type: 'date' },
  { key: 'closeDate', label: 'Close Date', type: 'date' },
  { key: 'source', label: 'Source', type: 'text' },
  { key: 'referredBy', label: 'Referred By', type: 'text' },
]

const MatterForm = ({ matter, onSave, onCancel, saving }) => {
  const isEdit = !!matter
  const [form, setForm] = useState(() => {
    if (matter) {
      return {
        name: matter.name || '',
        number: matter.number || '',
        attorney: matter.responsibleAttorney || matter.attorney || '',
        billingPartner: matter.billingPartner || '',
        clientName: matter.clientName || '',
        practiceArea: matter.practiceArea || '',
        feeArrangement: matter.feeArrangement || '',
        openDate: matter.openDate
          ? dayjs(matter.openDate).format('YYYY-MM-DD')
          : '',
        closeDate: matter.closeDate
          ? dayjs(matter.closeDate).format('YYYY-MM-DD')
          : '',
        source: matter.source || '',
        referredBy: matter.referredBy || '',
      }
    }
    return {
      name: '',
      number: '',
      attorney: '',
      billingPartner: '',
      clientName: '',
      practiceArea: '',
      feeArrangement: '',
      openDate: dayjs().format('YYYY-MM-DD'),
      closeDate: '',
      source: '',
      referredBy: '',
    }
  })

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!form.name.trim()) return
    onSave(form)
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {FIELD_CONFIG.map((field) => (
          <div
            key={field.key}
            className={field.key === 'name' ? 'sm:col-span-2' : ''}
          >
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {field.label}
              {field.required && (
                <span className="text-red-500 ml-1">*</span>
              )}
            </label>
            {field.type === 'select' ? (
              <select
                value={form[field.key]}
                onChange={(e) => handleChange(field.key, e.target.value)}
                className="w-full px-3 py-2 bg-white border border-gray-200
                  rounded-lg text-sm text-gray-900
                  focus:outline-none focus:ring-2 focus:ring-cb-accent/30
                  focus:border-cb-accent"
              >
                {field.options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt || '-- Select --'}
                  </option>
                ))}
              </select>
            ) : field.type === 'date' ? (
              <input
                type="date"
                value={form[field.key]}
                onChange={(e) => handleChange(field.key, e.target.value)}
                className="w-full px-3 py-2 bg-white border border-gray-200
                  rounded-lg text-sm text-gray-900
                  focus:outline-none focus:ring-2 focus:ring-cb-accent/30
                  focus:border-cb-accent"
              />
            ) : (
              <input
                type="text"
                value={form[field.key]}
                onChange={(e) => handleChange(field.key, e.target.value)}
                required={field.required}
                className="w-full px-3 py-2 bg-white border border-gray-200
                  rounded-lg text-sm text-gray-900 placeholder:text-gray-500
                  focus:outline-none focus:ring-2 focus:ring-cb-accent/30
                  focus:border-cb-accent"
                placeholder={field.label}
              />
            )}
          </div>
        ))}
      </div>

      <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
        <button
          type="button"
          onClick={onCancel}
          disabled={saving}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white
            border border-gray-200 rounded-lg hover:bg-gray-50
            transition-colors"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={saving || !form.name.trim()}
          className="px-4 py-2 text-sm font-medium text-white bg-cb-accent
            rounded-lg hover:bg-cb-accent/90 transition-colors shadow-sm
            disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {saving
            ? 'Saving...'
            : isEdit
              ? 'Save Changes'
              : 'Create Matter'}
        </button>
      </div>
    </form>
  )
}

export default MatterForm
